import { useEffect, useState } from 'react';
import { getAcceptedFoodTypes } from 'src/backend/team';

const useAcceptedFoodTypes = () => {
  const [acceptedFoodTypes, setAcceptedFoodTypes] = useState([]);

  const fetchData = () => getAcceptedFoodTypes().then(setAcceptedFoodTypes);
  useEffect(() => {
    fetchData();
  }, []);

  return { acceptedFoodTypes, invalidate: fetchData };
};

export default useAcceptedFoodTypes;
